import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchedulerItemOnMachineCRUD } from '../../../api/elite/dto/scheduler-item-on-machine.dto';
import { SchedulerItemOnMachineApiAbstract } from './item-on-machine';
import { ApiRouteSchedulingService } from '../../../api/elite/routes/scheduling.service';
import { SchedulerSubWorkOrderOnMachine } from '../models/sub-wo-on-machine';
import { SchedulerSubWorkOrder } from '../models/sub-work-order';
import { ApiRouteSubWorkOrderService } from '../../../api/elite/routes/sub-work-order.service';
import { ApiRouteSchedulingSubOrderService } from '../../../api/elite/routes/scheduling-sub-order.service';
import { SchedulerDragDropApiAbstract } from './drag-drop';
import { SchedulingApiRoutesDto } from '../../../api/elite/dto/scheduling.dto';

type AddBody = SchedulerItemOnMachineCRUD['add'];
type UpdateBody = SchedulerItemOnMachineCRUD['update'];
type StopBody = SchedulerItemOnMachineCRUD['stop'];

@Injectable({
  providedIn: 'root',
})
export class SchedulerSubWoOnMachineApiService
  implements SchedulerItemOnMachineApiAbstract, SchedulerDragDropApiAbstract
{
  protected readonly apiSchedulingRouter = inject(ApiRouteSchedulingService);
  protected readonly apiSubWorkOrderRouter = inject(
    ApiRouteSubWorkOrderService
  );
  protected readonly apiSubWorkOrderSchedulingRouter = inject(
    ApiRouteSchedulingSubOrderService
  );
  constructor() {}

  addItem(body: AddBody): Observable<SchedulerSubWorkOrderOnMachine> {
    return this.apiSchedulingRouter.addSubWorkOrderToMachine(body);
  }

  updateItem(body: UpdateBody): Observable<SchedulerSubWorkOrderOnMachine> {
    return this.apiSchedulingRouter.moveSubWorkOrderToOtherMachine(
      body
    ) as undefined as Observable<SchedulerSubWorkOrderOnMachine>;
  }

  removeItem(subWorkOrderId: number, machineId: number): Observable<any> {
    return this.apiSchedulingRouter.removeSubWorkOrderFromMachine(
      subWorkOrderId,
      machineId
    );
  }

  startItemOnMachine(
    subWorkOrderId: number,
    machineId: number
  ): Observable<any> {
    return this.apiSchedulingRouter.startSubWorkOrderOnMachine(
      subWorkOrderId,
      machineId
    );
  }

  stopItemOnMachine(body: StopBody): Observable<{
    currentSubWorkOrder: SchedulerSubWorkOrder;
    newSubWorkOrder: SchedulerSubWorkOrder;
    serialNumber?: number;
  }> {
    return this.apiSchedulingRouter.stopSubWorkOrderOnMachine(
      body
    ) as undefined as Observable<{
      currentSubWorkOrder: SchedulerSubWorkOrder;
      newSubWorkOrder: SchedulerSubWorkOrder;
      serialNumber?: number;
    }>;
  }

  v2StopItemOnMachine(
    body: SchedulingApiRoutesDto['registerProgress']['body']
  ): Observable<any> {
    return this.apiSchedulingRouter.registerProgressSubWorkOrder(body);
  }

  removeRunning(machineId: number, subWorkOrderId: number): Observable<any> {
    return this.apiSubWorkOrderSchedulingRouter.setAsNotRunning(
      machineId,
      subWorkOrderId
    );
  }

  updateRank(itemId: number, rank: string): Observable<any> {
    return this.apiSubWorkOrderRouter.update(itemId, { rank });
  }
}
